<ion-header>
  <ion-toolbar>
    <ion-title>Add a New Unique Boondock</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="close()">Close</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <div class="new-listing-wrapper">
    <div class="new-listing-option">
      <i class="icon-cnt-plus"></i>
      <p>Create a new, unique boondock from scratch.</p>
      <button type="button" class="cnt-button" (click)="add()">
        <div class="cnt-button-mock">Add New Boondock</div>
      </button>
    </div>
    <div class="new-listing-option">
      <form [formGroup]="duplicateForm" (ngSubmit)="duplicate()">
        <i class="icon-cnt-clone"></i>
        <p>Duplicate an existing boondock to get a head start.</p>
        <div class="duplicate-button-container">
          <ng-select
            class="dropdown w-dropdown dropdown-toggle"
            formControlName="duplicateBoondock"
            [clearable]="false"
            placeholder="Duplicate From..."
          >
            <ng-option [value]="boondock.id" *ngFor="let boondock of currentBoondocks">{{ boondock.name }}</ng-option>
          </ng-select>
        </div>
        <div class="_18px"></div>
        <button type="submit" class="cnt-button">
          <div class="cnt-button-copy">Create Duplicate</div>
        </button>
      </form>
    </div>
  </div>
  <div class="_18px"></div>
  <p>Create a different boondock for each location. Use the duplicate option to quick-start a new boondock.</p>
</ion-content>
